import styled, { css } from 'styled-components';
import Clickable from '@prisjakt/ui-clickable';

import { colorUtils, layout } from '@prisjakt/ui-base';

const wrapperStyles = css`
  width: 100%;
  display: grid;
  grid-gap: ${layout.measurements.spacing100};
  grid-template-columns: auto 1fr auto;
  justify-items: start;
  align-items: center;
  padding: ${layout.measurements.spacing050};
`;

export const ProductLink = styled(Clickable)`
  ${wrapperStyles};
  text-align: inherit;
  cursor: pointer;

  &:hover {
    background: ${p => colorUtils.setRgbaAlpha(p.theme.colors.base800, '0.04')};
  }
`;

export const Wrapper = styled.div`
  ${wrapperStyles}
`;

type ListItemProps = {
  isSelectingProducts?: boolean;
};

export const ListItem = styled.li<ListItemProps>`
  border-bottom: 1px solid ${({ theme }) => theme.colors.base200};
  display: block;
  position: relative;
`;

export const OfferLink = styled(Clickable)`
  justify-self: start;
  text-align: left;
  cursor: pointer;
`;

export const OfferStoreIconWrapper = styled.div`
  display: inline-flex;
  vertical-align: middle;
  margin-left: ${layout.measurements.spacing025};

  svg {
    fill: ${p => p.theme.colors.base400};
  }
`;
